import React, { memo } from 'react'
import { Button, Col, Table } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';

function AddressTable(props) {
    const { setAddress, address, setDlt, setAdd, setDefaultAdd, title } = props

    return (
        <React.Fragment>
            <Col xs={12} md={12} lg={12} className="px-0">
                <div className="app-header-wrapper heading-sm pad-15 d-flex  justify-content-between pb-0">
                    <p className="app-heading text-uppercase st-text-light st-fs-16 st-fw-700">{title}{" "}Addresses</p>
                </div>
                {address && <div className="app-card mb-3 mb-lg-4 pad-12-L pad-20-R" >
                    <div className="border st-border-light st-default-rounded-block mb-3 pad-20">

                        <Table className="mb-0 customer-address-table">
                            <thead className="border-bottom st-border-light customer-table-head">
                                <tr >
                                    <th className="column__firstname">
                                        <p className="text-capitalize">
                                            First Name
                                        </p>
                                    </th>
                                    <th className="column__lastname">
                                        <p className="text-capitalize">
                                            Last Name
                                        </p>
                                    </th>
                                    <th className="column__address">
                                        <p className="text-capitalize">
                                            Street Address
                                        </p>
                                    </th>
                                    <th className="column__city">
                                        <p className="text-capitalize">
                                            city
                                        </p>
                                    </th>

                                    <th className="column__state">
                                        <p className="text-capitalize">
                                            state
                                        </p>
                                    </th>
                                    <th className="column__country">
                                        <p className="text-capitalize">
                                            country
                                        </p>
                                    </th>
                                    <th className="column__zipcode">
                                        <p className="text-capitalize">
                                            postal code
                                        </p>
                                    </th>
                                    <th className="column__phone">
                                        <p className="text-capitalize">
                                            phone
                                        </p>
                                    </th>
                                    <th className="column__action text-center">
                                        <p className="text-capitalize">
                                            action
                                        </p>
                                    </th>
                                </tr>
                            </thead>

                            <tbody className="customer-table-body">
                                {address.length > 0 ? address.map((e, index) => {
                                    return (<tr key={index} className="border-top st-border-light">
                                        <td className="d-flex align-items-center" >
                                            <p className="text-uppercase">
                                                {e.shipping_first_name || "first name"}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="text-uppercase">
                                                {e.shipping_last_name}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="text-uppercase">
                                                {e.shipping_address}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="">
                                                {e.city}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="">
                                                {e.state}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="">
                                                {e.country}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="">
                                                {e.shipping_zipcode}
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="">
                                                {e.shipping_mobile}
                                            </p>
                                        </td>
                                        <td className="column__actions p-0">
                                            <div className="d-flex justify-content-center mt-1">
                                                <div className="header d-flex p-0" style={{ height: "auto", alignItems: "center" }} >
                                                    <div className="header-menu d-flex">
                                                        <div className="hm_item notifications ">
                                                            <Button
                                                                className="st-round-btn st-btn-sm st-btn-white d-flex align-items-center justify-content-center p-0"
                                                            >
                                                                <FeatherIcon
                                                                    icon="more-vertical"
                                                                    size="15"
                                                                    className="icon-main" />
                                                            </Button>
                                                            <div className="header-dropdown address-menu  p-0">
                                                                <div className="hd_inner st-default-rounded-block ">
                                                                    <div className="all-links">
                                                                        <Link to="#" className="link-item text-decoration-none d-flex"
                                                                            onClick={() => {
                                                                                setAdd(true)
                                                                                setAddress(e)
                                                                            }}
                                                                        >
                                                                            <div className="text media-body">
                                                                                <p className="message st-fs-14">
                                                                                    Edit
                                                                                </p>
                                                                            </div>
                                                                        </Link>
                                                                        <Link to="#" className="link-item text-decoration-none d-flex"
                                                                            onClick={() => {
                                                                                setAddress(e)
                                                                                setDlt(true)
                                                                            }}
                                                                        >
                                                                            <div className="text media-body">
                                                                                <p className="message st-fs-14">
                                                                                    Delete
                                                                                </p>
                                                                            </div>
                                                                        </Link>
                                                                        {!e.is_default && <Link to="#" className="link-item text-decoration-none d-flex"
                                                                            onClick={() => {
                                                                                setAddress(e)
                                                                                setDefaultAdd(true)
                                                                            }}
                                                                        >
                                                                            <div className="text media-body">
                                                                                <p className="message st-fs-14">
                                                                                    Set default
                                                                                </p>
                                                                            </div>
                                                                        </Link>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>)
                                }
                                ) : <tr>
                                    <td colSpan="9">
                                        <p className="no-data-found text-center st-fw-700 py-1">
                                            no data found
                                        </p>
                                    </td>
                                </tr>}
                            </tbody>
                        </Table>
                    </div>
                </div>}


            </Col >
        </React.Fragment>
    )
}

export default memo(AddressTable)